import styled, { css } from 'styled-components';
import boardSrc from 'assets/images/board.min.png';

export const SWrapper = styled.div<{ isPlaying: boolean }>`
  max-height: 660px;
  position: relative;
  padding: 65px 20px 30px;
  background-color: var(--board-color-1);
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 124%;
    left: 0;
    top: -24%;
    background-image: url('${boardSrc}');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    padding: 60px 20px 50px;
  }

  @media (max-width: 580px) and (max-aspect-ratio: 1/1) {
    padding: 40px 15px 35px;
  }

  @media (max-width: 480px) and (max-aspect-ratio: 1/1) {
    padding: 50px 12px 30px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 40px 10px 20px;
  }

  @media (max-width: 300px) and (max-aspect-ratio: 1/1) {
    padding: 30px 10px 15px;
  }
`;

export const SInner = styled.div<{
  disabled: boolean;
  cellAnimDelay: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ cellAnimDelay }) => cellAnimDelay}
`;
